import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { FieldArray } from '~src/settings/FormikWrapperForStubbing';
import { cssClass } from '~src/style';

import { UserDefinedPoolModel } from '../types/PoolModel';
import { DataConnectMultiPoolTableEntryNodes } from './DataConnectMultiPoolTableEntryNodes';
import { DataConnectMultiPoolTableEntryPool } from './DataConnectMultiPoolTableEntryPool';
import { ExpandPoolButton } from './ExpandPoolButton';
import { LoadingPoolsSpinner } from './LoadingPoolsSpinner';

export type DataConnectMultiPoolTableBodyProps = Readonly<{
  pools: Record<string, UserDefinedPoolModel>;
  existingPoolNames: ReadonlyArray<string>;
  siteId: string;
  refreshBaasEdgePools: () => void;
  hasLoadedBaasEdgePools: boolean;
}>;

export function DataConnectMultiPoolTableBody(props: DataConnectMultiPoolTableBodyProps) {
  const [expandedRowIndex, setExpandedRowIndex] = React.useState(-1);

  const pools: ReadonlyArray<UserDefinedPoolModel> = Object.values(props.pools);

  if(!props.hasLoadedBaasEdgePools) {
    return LoadingPoolsSpinner();
  }

  if (pools.length === 0) {
    return renderNoPoolsWarning();
  }

  return (
    <FieldArray
      name={''}
      render={() => (
        pools.map((pool: UserDefinedPoolModel, index) => (
          <tbody key={index}>
            <tr>
              <ExpandPoolButton
                isExpanded={expandedRowIndex === index}
                setExpanded={(expand: boolean) => setExpandedRowIndex(expand ? index : -1)}
                isDisabled={false}
              />
              <DataConnectMultiPoolTableEntryPool
                pool={pool}
                existingPoolNames={props.existingPoolNames}
                isExpanded={expandedRowIndex === index}
                siteId={props.siteId}
                refreshBaasEdgePools={props.refreshBaasEdgePools}
              />
            </tr>
            {(expandedRowIndex === index) &&
              <tr className={focusClass}>
                <td className={'tb-data-grid-separator-row'} />
                <td colSpan={5}>
                  <DataConnectMultiPoolTableEntryNodes
                    nodes={pool.cluster.nodes.concat()}
                    clusterId={pool.clusterId}
                    siteId={props.siteId}
                    poolId={pool.poolId}
                    poolName={pool.displayName}
                    refreshBaasEdgePools={props.refreshBaasEdgePools}
                  />
                </td>
              </tr>}
          </tbody>))
      )}
    />
  );
}

function renderNoPoolsWarning() {
  return (
    <tbody>
      <tr>
        <td colSpan={9}>
          <div className={'tb-data-grid-cell-text tb-data-grid-DataConnect-center'}>
            {Messages.dataConnectSiteSettingsPoolNotFoundWarning()}
          </div>
        </td>
      </tr>
    </tbody>);
}

const focusClass = cssClass('MultiPool', 'expanded-focus', {
  background: 'rgba(255, 255, 255, 0.00)',
  border: '1px solid #3498DB',
  boxShadow: '0 0 4px 0 #3498DB',
  borderRadius: '1px'
});
